import type ISupportRequest from '^types/support/ISupportRequest';

import apiClient from '.';

export const createSupportRequest = (data: ISupportRequest): Promise<void> => (
  apiClient.post('/SupportRequests', data)
);
